// Profile del management vive en MS-Aspect-Users.
// MS-Auth solo maneja credenciales y 2FA.
import AxiosService from 'plugins/TS-lib-utils-public/services/AxiosService';

class ManagementProfileService extends AxiosService {
  constructor() {
    super('aspect-users');
  }

  updateProfile = async (authUserId, data, { cancelToken = null } = {}) => {
    return await this.put(
      `/management/${authUserId}`,
      data,
      {
        headers: { Authorization: `Bearer ${this.getToken()}` },
        cancelToken,
      }
    );
  };
}

export default new ManagementProfileService();
